import { getDecimalDisplay } from 'utils/priceUtils';

/**
 * Get a formatted membership discount for display based on discount type, like "25%" or "$10.50"
 * Accepts either a raw discount or a newMemberOffer; for offers, returns null unless type is 'discount'.
 * @param {Object} [options] - Options.
 * @param {Object} [options.discount] - The discount to format (discountType, discountAmount).
 * @param {Object} [options.newMemberOffer] - A new member offer; only formatted when type === 'discount'.
 * @returns {string|null} The formatted discount or null if not applicable or type not supported.
 */
function getFormattedMembershipDiscount({ discount, newMemberOffer }) {
    let toFormat = null;
    if (newMemberOffer !== undefined) {
        toFormat = newMemberOffer?.type === 'discount' ? newMemberOffer : null;
    } else if (discount !== undefined) {
        toFormat = discount;
    }
    if (!toFormat) return null;

    const { discountAmount, discountType } = toFormat;
    switch (discountType) {
        case 'percent':
            return `${discountAmount}%`;
        case 'dollar':
            return `$${getDecimalDisplay(discountAmount)}`;
        default:
            return null;
    }
}

export { getFormattedMembershipDiscount };
